import './style.scss';
import InsuranceLogo from '../../../styles/assets/images/sv/rosgosstrah_logo.png';
import CalendarButton from "../../common/CalendarEvents/Button";
import {Button} from "reactstrap";
import {t} from "i18next";
import useCountry from "../../../lib/utils/hooks/useCountry";
import Divider from "../Divider";
import BookingEventDetails from "../BookingEventDetails";
import check from '../../../styles/assets/images/sv/check-green.svg';
import {PRODUCT_TYPES} from "sv-common/constants/certificates";
import {sendYandexMetrikaRgsEvent} from '../../../lib/utils/analytics';
import {useEffect, useMemo, useState} from "react";
import {usePublicEndpoints} from "../../../lib/api/usePublicEndpoints";
import {getDataOrder} from "../../../lib/utils/hooks/useGetDataOrder"
import loadImage from "../../../styles/assets/images/sv/loader.svg";
import InsuranceModal from "../InsuranceModal";
import {useOrderUpdate} from "../../../lib/utils/hooks/useOrderUpdate";

const PreparationSteps = (props) => {
    const { order = {}, userData, productType, globalInsuranceEnabled, globalInsuranceSport, globalInsuranceAdventure, setOrder } = props;

    const [insuranceModalVisible, setInsuranceModalVisible] = useState(false);

    const country = useCountry();
    const [payingUser, setPayingUser] = useState(userData);
    const {getUserCleanFields, getOrder} = usePublicEndpoints()
    const eventData = productType === 'slots' ? order.slot :
                      productType === 'arrivals' ? order.arrival :
                      '';
    let stepCounter = 0;
    const isInsuranceSlots = productType === 'slots'
                                    && globalInsuranceSport
                                    && order.eventInsurance
                                    && order.base?.insurance
                                    && order.slot?.insurance
    const isInsuranceAdventure = productType === 'arrivals'
                                    && globalInsuranceAdventure
                                    && order.arrival?.adventure_id?.insurance
                                    && order.arrival?.insurance

    const isDisplayInsurance = globalInsuranceEnabled && (isInsuranceSlots || isInsuranceAdventure)

    getDataOrder(order, setOrder, 'insurance_id');

    const sportExtraMaterials = [
        { link: 'https://silavetra.com/magazine/pervye-parusnye-trenirovki', name: t('final.firstTrains') },
        { link: 'https://silavetra.com/what_need_to_take_oreshka', name: t('final.takeOnTrain') },
        { link: 'https://silavetra.com/magazine/kak-odetsya-na-luch', name: t('final.luchClothes') },
        { link: 'https://silavetra.com/perchatki-dlya-yahtinga-ispytanie-v-boevyh-usloviyah', name: t('final.gloves') },
        { link: 'https://silavetra.com/experiment', name: t('final.shoe') },
    ]
    const extraMaterials = [...(productType === 'slots' ? sportExtraMaterials : []), ...(eventData?.extraMaterials || [])];

    const redirect = () => {
        sendYandexMetrikaRgsEvent('rgs-click_button-more_info')
        window.open('https://silavetra.rgs.online/', '_blank', 'noopener,noreferrer');
    }

    const openModal = () => {
        handleInsuranceModalVisible();
        sendYandexMetrikaRgsEvent('rgs-click_button-checkout')
    }

    const handleInsuranceModalVisible = () => {
        setInsuranceModalVisible(!insuranceModalVisible);
    }

    const updateOrder = useOrderUpdate({
        orderId: order?.id,
        getOrder,
        setOrder
    });

    useEffect(() => {
        if(order?.insurance_id) {
            getUserCleanFields()
                .then(res => {
                    setPayingUser(res)
                })
        }
    }, [order?.insurance_id]);

    useEffect(() => {
        if (payingUser?.id && !payingUser?.is_insurance && isDisplayInsurance) {
            setInsuranceModalVisible(true);
        }
    }, [payingUser?.id, isDisplayInsurance]);

    useEffect(() => {
        if (userData?.id) {
            setPayingUser(userData);
        }
    }, [userData?.id]);

    const firstInsurance = order?.insurance_id && payingUser?.is_insurance
    const secondInsurance = order?.insurance_id && order?.is_insured
    const isInsurance = firstInsurance || secondInsurance
    const isExpectationInsurance = order?.is_insured && !order?.insurance_id

    const defaultValue = useMemo(() => ({...payingUser, ...order?.participants?.[0], orderId: order?.id}), [order?.id, order?.participants?.[0], payingUser]);

    return order?.hasPaid && userData && (
        <>
            <Divider />
            <div>
                <h3 className="preparation-steps-title">{t('preparationSteps.mainTitle')}</h3>
                {isDisplayInsurance &&
                <div className="preparation">
                    <div className="preparation__number">{++stepCounter}</div>
                    <div className="preparation__content">
                        {isExpectationInsurance ?
                            <>
                                <h4 className="preparation__title">{t('preparationSteps.expectationInsurance')}</h4>
                                <div className="preparation__expectation">
                                    <div className="preparation__loader">
                                        <img className="preparation__loader__image" src={loadImage} alt="" />
                                    </div>
                                    <p>{t('preparationSteps.designInsurance')}</p>
                                </div>
                            </> :
                            (isInsurance ?
                                <>
                                    <h4 className="preparation__title">{t('preparationSteps.insuranceIssued')}</h4>
                                    <p>{t('preparationSteps.dataCanBeEdited')}</p>
                                    <div className="preparation__user">
                                        <img src={check} alt=""/>
                                        {country === 'RU' ?
                                            <>{payingUser?.first_name} {payingUser?.surname} {payingUser?.last_name}</> :
                                            <>{payingUser?.first_name_en} {payingUser?.last_name_en}</>
                                        }
                                    </div>
                                </> :
                                <>
                                    <h4 className="preparation__title">{t('preparationSteps.checkInsurance')}</h4>
                                    <p>{t('preparationSteps.firstBlockText')}</p>
                                    <div className="preparation__insurance">
                                        <img src={InsuranceLogo} alt={t('preparationSteps.insuranceCompany')}/>
                                        <p className="preparation__insurance_text">{t('preparationSteps.firstBlockInsurance')}</p>
                                        <Button type={'button'} onClick={() => openModal()}
                                                className={'btn-case-lower'}>
                                            {t('preparationSteps.buttonToCheckout')}
                                        </Button>
                                        <Button type={'button'} onClick={() => redirect()} className={'btn-muted'}>
                                            {t('preparationSteps.buttonReadMore')}
                                        </Button>
                                    </div>
                                </>
                            )
                        }
                    </div>
                </div>
                }
                <div className="preparation">
                    <div className="preparation__number">{++stepCounter}</div>
                    <div className="preparation__content">
                        <h4 className="preparation__title">{t('preparationSteps.addEventToCalendar')}</h4>

                        {order && productType === 'slots' &&
                            <BookingEventDetails eventInfo={{slot: order.slot, base: order.base, eventHideEventPlace: order?.eventHideEventPlace}} productType={PRODUCT_TYPES.SLOTS}/>
                        }
                        {order && productType === 'arrivals' &&
                            <BookingEventDetails eventInfo={{arrival: order.arrival}} productType={PRODUCT_TYPES.ARRIVALS}/>
                        }

                        <CalendarButton
                            name={eventData.name}
                            startDate={eventData.start_date}
                            endDate={eventData.end_date}
                            startTime={eventData.start_time}
                            endTime={eventData.end_time}
                            className={'btn-muted'}
                        />
                    </div>
                </div>
                {country === 'RU' && !!extraMaterials.length &&
                    <>
                        <div className="preparation">
                            <div className="preparation__number">{++stepCounter}</div>
                            <div className="preparation__content">
                                <h4 className="preparation__title">{t('preparationSteps.seeUseful')}</h4>
                                <div className="preparation__docs">
                                    {extraMaterials.map(material =>
                                        <div className="preparation__docs_item">
                                            <a href={material.link}
                                               target="_blank"
                                               rel="noopener noreferrer">
                                                {material.name}
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
            <Divider/>
            {insuranceModalVisible &&
                <InsuranceModal
                    handleModalVisible={handleInsuranceModalVisible}
                    defaultValues={defaultValue}
                    order={order}
                    productType={productType}
                    onSuccess={updateOrder}
                />
            }
        </>
    ) || null;
}

export default PreparationSteps;